import React, { FC, ReactElement } from 'react'
import styles from './ProductList.module.scss'
import { ComponentProductDto } from '~/modules/Products/Infrastructure/Dtos/ComponentProductDto'
import {
  RenderComponentStrategyResolver
} from '~/modules/Products/Infrastructure/RenderComponentStrategies/RenderComponentStrategyResolver'
import {
  RenderComponentMintedCardStrategy
} from '~/modules/Products/Infrastructure/RenderComponentStrategies/RenderComponentMintedCardStrategy'
import {
  RenderComponentMintedTrophyStrategy
} from '~/modules/Products/Infrastructure/RenderComponentStrategies/RenderComponentMintedTrophyStrategy'
import {
  RenderComponentMintableCardStrategy
} from '~/modules/Products/Infrastructure/RenderComponentStrategies/RenderComponentMintableCardStrategy'
import {
  RenderComponentMintableTrophyStrategy
} from '~/modules/Products/Infrastructure/RenderComponentStrategies/RenderComponentMintableTrophyStrategy'

interface Props {
  products: Array<ComponentProductDto>
}

export const ProductList: FC<Props> = ({ products }) => {
  const componentResolver = new RenderComponentStrategyResolver([
    new RenderComponentMintedCardStrategy(),
    new RenderComponentMintedTrophyStrategy(),
    new RenderComponentMintableCardStrategy(),
    new RenderComponentMintableTrophyStrategy(),
  ])

  const content: ReactElement[] = products.map((product) => {
    return componentResolver.resolve(product)
  })

  return (
    <div className={ styles.productList__container }>
      { content }
    </div>)
}
